export let dataProps = {
    id: 0,
    tag_name: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/saleTag/properties.js